<template>
    <div>
        <v-dialog
            v-model="display"
            transition
            width="500"
            persistent>
            <v-card flat>
                <v-card-title>{{ title }}</v-card-title>
                <div class="text-center" v-if="loading.data">
                    <v-progress-circular
                        indeterminate>
                    </v-progress-circular>
                </div>
                <v-card-text v-else>
                    <v-form 
                        ref="form"
                        v-model="valid">
                        <v-radio-group
                            v-model="form.is_active"
                            row
                            dense
                            @change="resetIsControlFiled"
                            >
                            <v-radio
                                :label="$t('title')"
                                :value="0">
                            </v-radio>
                            <v-radio
                                :label="$t('active')"
                                :value="1">
                            </v-radio>
                        </v-radio-group>
                        <v-text-field
                            v-model="form.name"
                            :rules="rules.name"
                            :label="$t('account_name')">
                        </v-text-field>
                        <v-autocomplete
                            v-model="form.type_id"
                            :rules="rules.type_id"
                            :label="$t('acccount_type')"
                            :items="accountTypes"
                            item-text="name"
                            item-value="id"
                            @change="fetchAccountGroup({ id: form.type_id }), clearCategoryID()"
                            >
                        </v-autocomplete>
                        <v-select
                            :disabled="!filterGroups.length"
                            v-model="form.category_id"
                            :label="$t('account_category')"
                            :items="filterGroups"
                            item-value="id"
                            :loading="loading.groups"
                            :menu-props="{
                                down: true,
                                offsetY: true
                            }"
                            clearable
                            item-text="name">
                        </v-select>
                        <v-select
                            v-model="form.currency_id"
                            :rules="rules.currency_id"
                            :label="$t('currency')"
                            :items="currencies"
                            item-text="name"
                            item-value="id"
                            >
                        </v-select>
                        <v-container
                            class="px-0"
                            fluid>
                            <v-checkbox
                                :disabled="!isGroup"
                                hide-details="auto"
                                dense
                                v-model="form.is_control"
                                :label="$t('is_control')"
                                :false-value="0"
                                :true-value="1">
                            </v-checkbox>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn :loading="loading.submit" :disabled="!valid" @click="submit" text>{{ $t('save_btn') }}</v-btn>
                    <v-btn @click="close" text>{{ $t('close_btn') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <RetryDialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit"/>
        <SnackbarAlert
            ref="snackbarAlert"/>
    </div>
</template>
<script>
import RetryDialog from '@/components/common/RetryDialog';
import SnackbarAlert from '@/components/common/SnackbarAlert';
import { mapActions, mapState } from 'vuex';
import { getIdempotentKey } from '../../services/ledger';
export default {
    name: "AccountDialog",
    components: {
        RetryDialog,
        SnackbarAlert
    },
    props: {
        id: {
            type: Number,
            required: false
        }
    },
    data() {
        return {
            display: true,
            valid: false,
            loading: {
                data: false,
                submit: false,
                groups: false
            },
            checkbox: null,
            groups:[],
            idempotentKey: null,
            form: {
                id: null,
                name: null,
                is_active: 0,
                is_control: 0,
                type_id: null,
                currency_id: 1,
                category_id: null,
                category : null
            },
            rules: {
                name: [
                    v => !!v || this.$t('rules_required')
                ],
                type_id: [
                    v => !!v || this.$t('rules_required')
                ],
                currency_id: [
                    v => !!v || this.$t('rules_required')
                ]
            }
        }
    },
    computed: {
        ...mapState("accounting/account", ["account", "accounts"]),
        ...mapState('accounting/currency', ["currencies"]),
        ...mapState('accounting/accountType', ["accountTypes"]),
        // ...mapState('accounting/accountGroup', ["groups"]),
        editMode() {
            return !this.notEditMode;
        },
        notEditMode() {
            return !this.id;
        },
        title() {
            if(this.notEditMode) return this.$t('new_account');
            else return this.$t('edit_account');
        },
        isGroup() {
            if(this.form.is_active == 0) {
                return true;
            } 
            else return false;
        },
        filterGroups() {
           return this.groups.filter(eacho => eacho.id != this.id)
        } 
    },
    watch: {
        'form.category_id' : {
            handler(newVal) {
                if(newVal == undefined) this.clearCategory();
            }
        }
    },
    methods: {
        ...mapActions('accounting/account', ["fetchAccounts","fetchAccount", "storeAccount", "updateAccount"]),
        ...mapActions('accounting/accountGroup', ["fetchGroups"]),
        ...mapActions('accounting/currency', ['fetchCurrencies']),
        ...mapActions('accounting/accountType', ['fetchAccountTypes']),
        ...mapActions('common/snackBar', ["setSnackBars"]),
        async createdDataFetch() {
            try {
                this.loading.data = true;
                if(this.editMode) {
                    await this.fetchAccount(this.id);
                    this.form = this._.clone(this.account);
                    await this.fetchAccountGroup({ id: this.form.type_id })
                }
                await Promise.all([this.fetchCurrencies(), this.fetchAccountTypes()]);
                this.loading.data = false;
            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({target:"createdDataFetch",message});
            }
        },
        resetIsControlFiled(){
            if(this.form.is_active == 1) this.form.is_control = 0; 
        },
        fetchIdempotentKey() {
            getIdempotentKey().then(resp => this.idempotentKey = resp.data.key);
        },
        async fetchAccountGroup(params) {
            try{
                this.loading.groups = true;
                this.groups = [];
                let result =  await this.fetchGroups({ type_id: params.id });
                this.groups = result.data;
                this.loading.groups = false;
            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.setSnackBars({color: "error", message});
            }
        },
        clearCategoryID() {
            this.form.category_id = null;
        },
        submit() {
            this.loading.submit = true;
            if(this.notEditMode) {
                this.storeAccount({idempotentKey: this.idempotentKey, ...this.form})
                    .then(() => {
                        this.close();
                        this.$emit('submit');
                        this.setSnackBars({color: "success", message: this.$t("record_save_success")});
                    }).catch((error) => {
                        this.loading.submit = false;
                        let message = error.response ? error.response.data.message : error.message;
                        this.setSnackBars({color: "error", message});
                    })
            } else {
                this.updateAccount(this.form)
                    .then(() => {
                        this.close();
                        this.$emit('submit');
                        this.setSnackBars({color: "success", message: this.$t("record_update_success")});
                    })
                    .catch((error) => {
                        this.loading.submit = false;
                        let message = error.response ? error.response.data.message : error;
                        this.setSnackBars({color: "error", message});
                    })
            }
        },
        onRetryDialogSubmit(params){
            if(params.target == "createdDataFetch") {
                if(params.retry) this.createdDataFetch();
            }
        },
        clearCategory() {
            this.form.category_id = null;
            this.form.category = null;
        },
        close() {
            this.display = false;
            setTimeout(() => {
                this.$emit('close');
            }, 100)
        }
    },
    created () {
        this.createdDataFetch();
        this.fetchIdempotentKey();
    },
    updated() {
        this.$on('click:clear', () => {
            this.form.category_id = null;
        })
    }
}
</script>